import React from "react";
import styled from "styled-components";
import { openFeedTextModal } from "../../store/actions";
import ProfileMenu from "../../components/Perfil/ProfileMenu/ProfileMenu";
import MisPostulaciones from "../../components/Dashboard/MisPostulaciones/MisPostulaciones";
import Proyectos from "../../components/Dashboard/MisProyectos/MisProyectos";
import { connect } from "react-redux";

const Container = styled.div`
  padding-top: 100px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const ProjectsPostulationsWrapper = styled.div`
  position: sticky;
  top: 98px;
  left: 0;
  z-index: 800;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 900px) {
    display: none;
  }
`;
const OverflowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 800;
  overflow-y: visible;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 283px;
  @media (max-width: 900px) {
    display: none;
  }
`;
const MisProyectos = ({openFeedTextModal, ...props}) => {

  return (
    <Container>
      <Proyectos fromPage />
      <ProjectsPostulationsWrapper>
        <OverflowWrapper>       
          <MisPostulaciones />
        </OverflowWrapper>
      </ProjectsPostulationsWrapper>
      {props.profileMenu ? <ProfileMenu /> : null}
    </Container>
  );
};

const mapStateToProps = state => {
  return {
    profileMenu: state.profile.menuShow,
  };
};

export default connect(mapStateToProps, {
  openFeedTextModal,
})(MisProyectos);
